/**
 * Marketing hero — the H1 + subtitle that lives high on the page,
 * directly under the settings bar and above the ad slot.
 *
 * Split out of `MarketingContent.tsx` so the H1 can render early in
 * the DOM (good for SEO — the primary heading shouldn't sit below the
 * receipt tool) while the rest of the marketing prose (How it works,
 * Why local OCR, etc.) stays where it always was, below the export
 * controls. The component pulls the same MARKETING_BY_LANG data so
 * translations stay in one place.
 */

import type { UiLangCode } from '../lib/i18n';
import { MARKETING_BY_LANG, type MarketingStrings } from './MarketingContent.i18n';

interface Props {
  lang: UiLangCode;
}

export function MarketingHero({ lang }: Props): JSX.Element {
  // noUncheckedIndexedAccess turns the lookup into `T | undefined`; the
  // English fallback keeps the component well-typed at runtime.
  const m: MarketingStrings = (MARKETING_BY_LANG[lang] ??
    MARKETING_BY_LANG.eng) as MarketingStrings;

  return (
    <div className="space-y-2 px-1">
      <h1 className="text-[1.215rem] font-bold tracking-tight text-slate-900 sm:text-[1.51875rem] dark:text-slate-50">
        {m.hero.title}
      </h1>
      <p className="text-sm text-slate-600 sm:text-base dark:text-slate-400">
        {m.hero.subtitle}
      </p>
    </div>
  );
}
